export default __webpack_public_path__ + "images/react/utils/icons/assets/objective_expansion.png";